import { mapEntries, invertObj, mapObj } from '@uds/capra';
import cookies from 'browser-cookies';

const parseCategory = str => {
  const [id, flag] = str.split(':');
  const value = flag === '0';
  return {
    id,
    value
  };
};
const getCategoryIndex = category => {
  var _category$id;
  return Number(((_category$id = category.id) != null ? _category$id : '').replace(/[a-zA-Z]/g, ''));
};
const parseContent = function () {
  let str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return str.split('|').map(parseCategory).sort((a, b) => {
    const i = getCategoryIndex(a);
    const j = getCategoryIndex(b);
    return i - j;
  });
};
const parse = consent => {
  return parseContent(consent);
};
var parse$1 = parse;

const idsToAliases = (ids, mappings) => {
  return mapEntries(ids != null ? ids : {}, entries => {
    return entries.filter(_ref => {
      let [id] = _ref;
      return mappings[id] != null;
    }).map(_ref2 => {
      let [id, value] = _ref2;
      const alias = mappings[id];
      return [alias, value];
    });
  });
};
const aliasesToIds = (aliases, mappings) => {
  const iMappings = invertObj(mappings);
  return mapObj(aliases != null ? aliases : {}, (alias, value) => {
    const id = iMappings[alias];
    return [id, value];
  });
};
const aliasListToIdList = (aliases, mappings) => {
  const iMappings = invertObj(mappings);
  return aliases.map(alias => {
    const id = iMappings[alias];
    return id;
  });
};

const get = (mappings, consent, categories) => {
  var _aliasListToIdList;
  const allIds = (_aliasListToIdList = aliasListToIdList(categories != null ? categories : [], mappings)) != null ? _aliasListToIdList : [];
  const defaultOptOuts = allIds.reduce((acc, id) => {
    return {
      ...acc,
      [id]: false
    };
  }, {});
  const parsed = parse$1(consent).reduce((acc, category) => {
    return {
      ...acc,
      [category.id]: category.value
    };
  }, defaultOptOuts);
  let ids = parsed;
  if (categories) {
    ids = allIds.reduce((acc, id) => ({
      ...acc,
      [id]: parsed[id]
    }), {});
  }
  return idsToAliases(ids, mappings);
};
var get$1 = get;

const CONSENT_COOKIE = 'OPTOUTMULTI';
const DEFAULT_CATEGORY = 'default';
const DEFAULT_ID = 'c1';
// default cookie consent value that tealium set
const DEFAULT_CONSENT = '0:0|c1:1|c2:1|c3:1|c4:1';

const getByOrder = (consent, categories) => {
  const parsed = parse$1(consent);
  // we should always have a default category
  // if one isn't passed in, we should insert it
  const defaultCategoryIndex = parsed.map(category => category.id).indexOf(DEFAULT_ID);
  const hasDefaultCategory = categories.includes(DEFAULT_CATEGORY);
  if (defaultCategoryIndex >= 0 && !hasDefaultCategory) {
    // eslint-disable-next-line no-param-reassign
    categories = categories.slice();
    categories.splice(defaultCategoryIndex, 0, 'default');
  }
  return categories.reduce((acc, key, i) => {
    return {
      ...acc,
      [key]: parsed[i]
    };
  }, {});
};
var getByOrder$1 = getByOrder;

const set = (mappings, consent, categories) => {
  const idCategories = aliasesToIds(categories, mappings);
  const previous = get$1(mappings, consent);
  const previousIdCategories = aliasesToIds(previous, mappings);
  const str = Object.keys(previousIdCategories).map(id => {
    const category = idCategories[id];
    const flag = category ? 0 : 1;
    return `${id}:${flag}`;
  }).join('|');
  return str;
};
var set$1 = set;

class Consent {
  constructor(mappings) {
    this.mappings = mappings != null ? mappings : {};
  }
  get(categories, consent) {
    return get$1(this.mappings, consent, categories);
  }
  set(categories, consent) {
    return set$1(this.mappings, consent, categories);
  }
  getByOrder(categories, consent) {
    return getByOrder$1(consent, categories);
  }
}
var Consent$1 = Consent;

const getDomain = window => {
  var _window$utag, _window$utag$cfg;
  const utagDomain = (_window$utag = window.utag) === null || _window$utag === void 0 ? void 0 : (_window$utag$cfg = _window$utag.cfg) === null || _window$utag$cfg === void 0 ? void 0 : _window$utag$cfg.domain;
  if (utagDomain != null) {
    return utagDomain;
  }

  /**
   * copied from utag.js to set the cookie on the same domain as tealium, if tealium not loaded
   * ote.123-reg.co.uk -> .123-reg.co.uk
   */
  try {
    const hostname = `${window.location.hostname}`;
    const hostnameParts = hostname.split('.');
    const pathSplit = /\.co\.|\.com\.|\.org\.|\.edu\.|\.net\.|\.asn\./.test(hostname) ? 3 : 2;
    const domain = hostnameParts.splice(hostnameParts.length - pathSplit, pathSplit).join('.');
    return domain;
  } catch (e) {
    return window.location.hostname;
  }
};

class CookieConsent {
  constructor(mappings, cookieOptions) {
    this.mappings = mappings != null ? mappings : {};
    this.cookieOptions = cookieOptions;
    this.window = window;
    this.cookies = cookies;
  }
  get(categories) {
    var _this$cookies$get;
    return get$1(this.mappings, (_this$cookies$get = this.cookies.get(CONSENT_COOKIE)) != null ? _this$cookies$get : DEFAULT_CONSENT, categories);
  }
  set(categories) {
    var _this$cookies$get2;
    const result = set$1(this.mappings, (_this$cookies$get2 = this.cookies.get(CONSENT_COOKIE)) != null ? _this$cookies$get2 : DEFAULT_CONSENT, categories);
    this.cookies.set(CONSENT_COOKIE, result, {
      domain: getDomain(this.window),
      ...this.cookieOptions
    });
    return result;
  }
  getByOrder(categories) {
    var _this$cookies$get3;
    return getByOrder$1((_this$cookies$get3 = this.cookies.get(CONSENT_COOKIE)) != null ? _this$cookies$get3 : DEFAULT_CONSENT, categories);
  }
}
var CookieConsent$1 = CookieConsent;

class Identity {
  constructor(mappings, consent) {
    this.mappings = mappings != null ? mappings : {};
    this.consent = consent != null ? consent : '';
  }
  get(categories) {
    return get$1(this.mappings, this.consent, categories);
  }
  set(categories) {
    this.consent = set$1(this.mappings, this.consent, categories);
    return this.consent;
  }
  getByOrder(categories) {
    return getByOrder$1(this.consent, categories);
  }
}
var Identity$1 = Identity;

export { Consent$1 as Consent, CookieConsent$1 as CookieConsent, Identity$1 as IdentityConsent };
